import {AVATAR_CHANGED, MEMBER_DISABLE_GUESTBOOK_SUCCESS} from './member';

export const GET_CURRENT_USER = 'GET_CURRENT_USER';
export const GET_CURRENT_USER_REQUEST = 'GET_CURRENT_USER_REQUEST';
export const GET_CURRENT_USER_SUCCESS = 'GET_CURRENT_USER_SUCCESS';
export const GET_CURRENT_USER_FAILURE = 'GET_CURRENT_USER_FAILURE';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';


export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

const SET_CURRENT_USER_COUNTERS = 'SET_CURRENT_USER_COUNTERS';

const GET_MEMBER_MESSAGELIST_SUCCESS = 'GET_MEMBER_MESSAGELIST_SUCCESS';
const GET_MEMBER_MESSAGEDIALOG_SUCCESS = 'GET_MEMBER_MESSAGEDIALOG_SUCCESS';
const GET_NEW_MEMBER_MESSAGEDIALOG_SUCCESS = 'GET_NEW_MEMBER_MESSAGEDIALOG_SUCCESS';


import * as backend from 'backend-helpers/member';

// todo: make 'bobtvuser' Node module
import {BobTVUser} from 'bobtvuser';

export default function currentUser(state = new BobTVUser({}), action) {
    switch (action.type) {
        case GET_CURRENT_USER_SUCCESS:
            let { user } = action.result.data;
            return new BobTVUser(user ? {...user, _loaded: true} : {});

        case LOGIN_SUCCESS:
            return new BobTVUser({ ...action.user, _loaded: true });

        case SET_CURRENT_USER:
            return new BobTVUser({ ...action.user, _loaded: true });

        case LOGOUT_SUCCESS:
            return new BobTVUser({});

        case AVATAR_CHANGED:
            return new BobTVUser({
                ...state,
                avatar_url: action.avatarUrl
            });

        case MEMBER_DISABLE_GUESTBOOK_SUCCESS:
            return new BobTVUser({
                ...state,
                guestbook_disabled: action.guestbookDisabled
            });

        case GET_MEMBER_MESSAGELIST_SUCCESS:
        case GET_MEMBER_MESSAGEDIALOG_SUCCESS:
        case GET_NEW_MEMBER_MESSAGEDIALOG_SUCCESS:
            const { newCount } = action.result.data.data;
            state.counters.count_my_messages = newCount;
            return new BobTVUser({...state});

        case SET_CURRENT_USER_COUNTERS:
            const { data: { data } } = action;
            return new BobTVUser({
                ...state,
                counters: {
                    ...state.counters,
                    [data.name]: data.value,
                }
            });
        default:
            return state;
    }
}

// action creators
export const getCurrentUser = () => ({type: GET_CURRENT_USER});

export const setCurrentUser  = user => ({type: SET_CURRENT_USER, user}); 

export const setCurrentUserCounters = data => ({ type: SET_CURRENT_USER_COUNTERS, data });

export const logout = () => ({
    types: [LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAILURE],
    promise: backend.logout()
});



// WEBPACK FOOTER //
// ./src/reducers/currentUser.js